import { create } from "zustand";

type DocumentType = "rfq" | "audit" | "budget" | "code" | "resolution";

type GovernmentDocumentFormValues = {
  documentType?: DocumentType;
  number?: string;
  title?: string;
  description?: string;
  date?: Date;
  status?: "current" | "archived" | "proposed" | "open" | "closed" | "awarded";
  category?: string;
  documentMediaId?: string;
  // RFQ fields
  deadlineDate?: Date;
  awardedTo?: string;
  estimatedValue?: string;
  // Budget/Audit fields
  fiscalYear?: number;
  // Code fields
  codeSection?: string;
  effectiveDate?: Date;
};

type State = {
  isOpen: boolean;
  documentId: string | null;
  defaultValues: GovernmentDocumentFormValues;
  activeTab: DocumentType;
};

type Actions = {
  setIsModalOpen: (isOpen: boolean) => void;
  setDocumentId: (id: string | null) => void;
  setDefaultValues: (values: GovernmentDocumentFormValues) => void;
  setActiveTab: (tab: DocumentType) => void;
};

export const useGovernmentDocumentsModal = create<State & Actions>((set) => ({
  isOpen: false,
  documentId: null,
  defaultValues: {},
  activeTab: "rfq",
  setIsModalOpen: (isOpen) => set({ isOpen }),
  setDocumentId: (id) => set({ documentId: id }),
  setDefaultValues: (values) => set({ defaultValues: values }),
  setActiveTab: (tab) => set({ activeTab: tab }),
}));
